<div class="d-inline-block me-2" *ngFor="let tag of tags">
	<span class="btn btn-outline-duo">
		{{ tag }}
		<button class="btn-close btn-close-white ms-2" (click)="removeTag(tag)"></button>
	</span>
</div>
<div class="input-group">
	<input class="form-control" [(ngModel)]="newTag" placeholder="Add tag..." (keyup.enter)="addTag()" />
</div>
